import { render } from "./BbahrmView.vue?vue&type=template&id=3d3c4672"
import script from "./BbahrmView.vue?vue&type=script&lang=js"
export * from "./BbahrmView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__